<template>
    <md-card>
        <md-table v-model="searchedTableData" :md-sort="rowColumnHeader" md-sort-order="asc">
            <md-table-toolbar>
                <div class="md-toolbar-section-start table-toolbar-title">
                    <h1 class="md-title">{{ cell.options.title.text }}</h1>
                </div>
                <md-field md-clearable class="md-toolbar-section-end">
                    <md-input :placeholder="`Search by ${rowColumnHeader}...`" v-model="search" @input="searchOnTable" class="table-toolbar-search" />
                </md-field>
            </md-table-toolbar>

            <md-table-empty-state
            :md-label="`No ${rowColumnHeader} found`"
            :md-description="`No '${rowColumnHeader}' found for this '${search}' query. Try a different search term.`">
            <md-button class="md-primary md-raised" @click="search=''">Clear Search</md-button>
        </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell 
                    v-for="(key, index) in Object.keys(item)" 
                    :key="key+index"
                    :md-label="key"
                    :md-sort-by="key"
                    >
                    {{ formatTableCell(item, key) }}
                </md-table-cell>
            </md-table-row>
        </md-table>
        <md-card-actions>
            <md-button class="md-icon-button" v-on:click="$emit('save-csv')">
                <md-icon>file_download</md-icon>
            </md-button>
        </md-card-actions>
    </md-card>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/

export default {
    name: "DashboardTable",
    props: {
        cell: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        tableData: [],
        rowColumnHeader: 'index',
        search: null,
        searchedTableData: []
    }),
    watch: {
        cell: {
            deep: false,
            immediate: true,
            /**
             * Converts cell to expected format for table items:
             * item: {
             *    rowColumnHeader: rowValue,
             *    key1: rowValue,
             *    ...
             * }
             */
            handler(cell){
                let datasets = cell.data.datasets;
                let labels = cell.data.labels;
                let options = cell.options;
                let data = []

                datasets.forEach((dataset) => {
                    let dataObject = {}
                    let rowColumnHeader = 'index';

                    if(options.rowColumnHeader) {
                        if(options.rowColumnHeader.display && options.rowColumnHeader.text){
                            rowColumnHeader = options.rowColumnHeader.text;
                        }
                    }
                    dataObject[rowColumnHeader] = dataset.label;
                    this.rowColumnHeader = rowColumnHeader;
                    labels.forEach((label, index) => {
                        dataObject[label] = dataset.data[index]
                    })

                    data.push(dataObject)
                })

                this.tableData = data
                this.searchedTableData = data
            }

        }
    },
    methods: {
        searchOnTable() {
            this.searchedTableData = this.searchByIndex(this.tableData, this.search, this.rowColumnHeader)
        },
        searchByIndex(items, term, key) {
            const toLower = text => {
                return text.toString().toLowerCase()
            }

            if(term) {
                return items.filter(item => toLower(item[key]).includes(toLower(term)))
            }

            return items
        },
        formatTableCell(item, key) {
            // row column header is the first column and assumed to be a String
            // this means we should not try and limit it to 2dp
            if(key === this.rowColumnHeader || typeof item[key] === "string"){
                return item[key]
            } else {
                return Number(parseFloat(item[key]).toFixed(2)).toLocaleString()
            }
        }
    }
}
</script>

<style scoped>
.table-toolbar-title {
    min-width: 60%;
    text-overflow: ellipsis;
}
.table-toolbar-search {
    text-overflow: ellipsis;
}
</style>